<template>
  <div class="space-y-16 pt-12">
    <!-- Intro, All Major Leagues -->
    <div class="grid gap-4 max-w-xl mx-auto text-center">
      <img class="w-32 md:w-40 mx-auto mb-2" src="~/assets/images/fans48-logo.svg">
      <h2 class="font-heading font-bold text-3xl md:text-4xl lg:text-6xl" v-html="$t('pages.start.blocks.leagues.heading').replace('\n', '<br>')" />
      <p class="text-sm md:text-base" v-html="$t('pages.start.blocks.leagues.body')" />
      <StartLeagues class="mt-4" />
    </div>

    <!-- Two Up, A Customised Experience -->
    <div class="grid md:flex flex-row items-center gap-6 md:gap-12 md:-mx-20 lg:-mx-40">
      <img class="flex-1 rounded-3xl overflow-hidden aspect-[4/3] object-cover" src="~/assets/images/landing-page/phone.jpg">
      <div class="flex-1 _p-8">
        <div class="grid gap-2">
          <h2 class="font-heading font-bold text-3xl md:text-4xl" v-html="$t('pages.start.blocks.customised.heading').replace('\n', '<br>')" />
          <p class="text-sm md:text-base" v-html="$t('pages.start.blocks.customised.body')" />
          <ul class="grid gap-3 mt-2">
            <li class="text-base flex items-center gap-2" v-for="bullet in 3" :key="bullet">
              <AtomIcon name="check-circle" class="text-green-500" />
              <span class="font-normal" v-html="$t(`pages.start.blocks.customised.bullets[${bullet-1}].leading`)" />
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Teams -->
    <StartTeams class="md:-mx-20 lg:-mx-40" />
    
    <!-- Multilingual Global Platform -->
    <div class="rounded-3xl overflow-hidden relative text-white md:-mx-20 lg:-mx-40">
      <div class="absolute top-1/4 left-0 w-full p-8 -translate-y-1/2">
        <div class="grid gap-4 max-w-2xl mx-auto text-center">
          <h2 class="font-heading font-bold text-2xl md:text-4xl" v-html="$t('pages.start.blocks.multilingual.heading').replace('\n', '<br>')" />
          <p class="text-sm md:text-base" v-html="$t('pages.start.blocks.multilingual.body')" />
        </div>
      </div>
      <img class="w-full aspect-[3/5] md:aspect-[4/3] object-cover" src="~/assets/images/landing-page/world.jpg">
    </div>

    <StartGames />
  </div>
</template>
